export const TERM_CARD_BACKGROUND_CLASSES = [
  'bg-lime-300/90 dark:bg-lime-400/90',
  'bg-rose-300/90 dark:bg-rose-400/90',
  'bg-sky-300/90 dark:bg-sky-400/90',
  'bg-amber-300/90 dark:bg-amber-400/90',
  'bg-emerald-300/90 dark:bg-emerald-400/90',
  'bg-violet-300/90 dark:bg-violet-400/90',
  'bg-orange-300/90 dark:bg-orange-400/90',
];

const FALLBACK_BACKGROUND_CLASS = 'bg-primary/30 dark:bg-primary/20';
const FALLBACK_TEXT_CLASS = 'text-primary-500 dark:text-primary-200';

const TERM_CARD_TEXT_CLASSES = [
  'text-lime-400 dark:text-lime-300',
  'text-rose-400 dark:text-rose-300',
  'text-sky-400 dark:text-sky-300',
  'text-amber-400 dark:text-amber-300',
  'text-emerald-400 dark:text-emerald-300',
  'text-violet-400 dark:text-violet-300',
  'text-orange-400 dark:text-orange-300',
];

export interface TermColorInfo {
  colorIndex: number;
  backgroundClass: string;
  lightBackgroundClass: string;
  darkBackgroundClass?: string;
  textClass: string;
}

const buildColorKey = (term?: string, scenarioName?: string) => {
  const normalizedTerm = term?.trim().toLowerCase() ?? '';
  const normalizedScenario = scenarioName?.trim().toLowerCase() ?? 'default';
  return `${normalizedScenario}::${normalizedTerm || 'unknown'}`;
};

const stringHash = (value: string) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
};

export const getTermColorInfo = (
  term?: string,
  scenarioName?: string
): TermColorInfo => {
  const paletteSize = TERM_CARD_BACKGROUND_CLASSES.length;
  if (paletteSize === 0) {
    return {
      colorIndex: 0,
      backgroundClass: FALLBACK_BACKGROUND_CLASS,
      lightBackgroundClass: FALLBACK_BACKGROUND_CLASS.split(' ')[0],
      darkBackgroundClass: FALLBACK_BACKGROUND_CLASS.split(' ').find((cls) => cls.startsWith('dark:')),
      textClass: FALLBACK_TEXT_CLASS,
    };
  }

  const key = buildColorKey(term, scenarioName);
  const colorIndex = stringHash(key) % paletteSize;
  const backgroundClass = TERM_CARD_BACKGROUND_CLASSES[colorIndex] ?? FALLBACK_BACKGROUND_CLASS;
  const textClass = TERM_CARD_TEXT_CLASSES[colorIndex] ?? FALLBACK_TEXT_CLASS;
  const classParts = backgroundClass.split(/\s+/).filter(Boolean);
  const lightBackgroundClass = classParts.find((cls) => !cls.includes(':')) ?? FALLBACK_BACKGROUND_CLASS;
  const darkBackgroundClass = classParts.find((cls) => cls.startsWith('dark:'));

  return {
    colorIndex,
    backgroundClass,
    lightBackgroundClass,
    darkBackgroundClass,
    textClass,
  };
};

export const getTermColorKey = (term?: string, scenarioName?: string) =>
  buildColorKey(term, scenarioName);
